<template>
  <div class="container" :class="isShow?'isHidden':''">
    <!--预约医生列表-->
    <div class="accept" v-if="status==0">
      <!--<div class="help_head">-->
        <!--<div class="help_head_msg">可预约: 2018-08-01 至 2018-08-31</div>-->
        <!--<div class="help_head_all">全部时间 <img src="@/assets/images/ap@2x.png" alt=""></div>-->
      <!--</div>-->

      <el-date-picker
        class="picker"
        v-model="value1"
        type="date"
        size="large"
        placeholder="选择日期"
        :editable="false"
        @focus="calFocus"
        @blur="calBlur"
        @change="changeDate"
        prefix-icon="el-icon-arrow-down"
        :picker-options="pickerOptions0">
      </el-date-picker>

      <div class="help_days">
        <div v-for="(day,index) in dayList" :class="{active: activeIndex == index}" class="help_list_box" @click="getDocListByDate(day.date,index)">
          <span>{{day.weekDay}}</span>
          <span>{{day.day}}</span>
        </div>
      </div>

      <div class="help_list">
        <ul>
          <li v-for="doc in docList" @click="toApplyTips(doc.quantity,doc.scheduleId,doc.period)">
            <img class="lay_row" :src="doc.avatar" alt="">
            <div class="lay_row marLeft10">
              <div><span class="doc_name">{{doc.name}}</span><span class="doc_job">主任医师</span></div>
              <div class="doc_time doc_am" v-if="doc.showSec==1">上午</div>
              <div class="doc_time doc_pm" v-if="doc.showSec==2">下午</div>
              <div class="doc_time doc_no" v-if="doc.showSec==3">上午</div>
              <div class="doc_time doc_no" v-if="doc.showSec==4">下午</div>
            </div>
            <div class="lay_row btn_apply" :class="doc.showSec==3||doc.showSec==4?'unApply':''">预约</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="mask" v-if="isShow"></div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { base, userInfo } from '@/apis'
  import hosts from '@/apis/hostConfig'
  import { order } from '@/apis'
  export default {
    data(){
      return {
        status:10,
        activeIndex:0,
        isShow:false,
        value1:(new Date()),
        pickerOptions0: {
          disabledDate(time) {
            let curDate = (new Date()).getTime();
            let one = 30 * 24 * 3600 * 1000;
            let threeMonths = curDate + one;
            return time.getTime() > threeMonths || time.getTime() < Date.now();
          },
        },
        docList:[],// 所选时间当天的医生列表
        dayForSelect: this.getyyyyMMdd(new Date(new Date().getTime()+24*60*60*1000)), // 所选的当前时间
        dayList:[],
      }
    },
    computed:mapState({
      openid: state => state.openid,
      patientId: state => state.patientId,
      patientUUID: state => state.patientUUID,
      // orderNo: state => state.orderNo,
      orderFee: state => state.orderFee,
    }),
    created(){
      this.getPatientsInfo();
    },
    mounted(){
      this.getWeekDaysList(this.value1);
      window.addEventListener("popstate", function(e) {
        WeixinJSBridge.call('closeWindow');
      }, false);
    },
    methods:{
      // 获取病人信息
      getPatientsInfo(){
        this.axios.get(userInfo.queryPatientsInfo,{
          params:{
            openId:this.openid
          }
        }).then((res)=>{
          let data = res.data.data
          let hasBinded = res.data.data.hasBinded;
          let patientDto = res.data.data.patientDto;

          if(!hasBinded){
            // 未绑定个人信息
            this.$router.push({
              path:'/goBind'
            })
          }else{
            if(patientDto.uuid==''||patientDto.uuid=='null'||patientDto.uuid==null){
              // 已绑定个人信息，但是没有uuid，没有门诊预约信息
              this.$router.push({
                path:'/unAccept'
              })
            }else{
              // 已绑定
              localStorage.setItem('patientId',patientDto.id);
              localStorage.setItem('patientUUID',patientDto.uuid);
              this.store.commit('set_user_id',{
                patientId:patientDto.id,
                patientUUID:patientDto.uuid
              });
              // 通过病人UUID请求病人当前的订单信息
              this.getOrderStatus(patientDto.id,patientDto.uuid)
            }
          }
        }).catch((err)=>{
          console.log(err);
        });
      },
      // 获取订单状态
      getOrderStatus(patientId,patientUUID){
        this.axios.get(order.orderStatus,{
          params:{
            patientId:patientId,
            patientUUID:patientUUID
          }
        }).then((res)=>{

          let data = res.data.data;
          let flag = data.flag;

//          flag = 0 ;   // 记得删除，测试写死数据！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！

          this.status = flag;

          switch(flag){
            case 0:   // 返回医生列表
              this.getDocList(patientUUID);
              break;
            case 1:   // 待支付
              this.store.commit('get_order_no',data.orderNo);
              this.$router.push({
                path:'/payApply',
                query:{
                  patientId:patientId,
                  patientUUID:patientUUID,
                  orderNo:data.orderNo
                }
              });
              break;
            case 2:   // 支付完成
              this.store.commit('get_order_no',data.orderNo);
              this.$router.push({
                path:'/applyDetail',
                query:{
                  patientId:patientId,
                  patientUUID:patientUUID,
                  resumeCancelNum:data.resumeCancelNum,
                  orderNo:data.orderNo
                }
              });
              break;
            case 3:   // 取消达到上限
              this.$router.push({
                path:'/applyThird'
              });
              break;
          }
        }).catch((err)=>{
          console.log(err);
        });
      },
      // 获取医生列表
      getDocList(patientUUID){
        this.axios.get(base.proxyGet,{
          params:{
            url:hosts[process.env.NODE_ENV].emr+'/Patients/'+patientUUID+'/appointments/schedulings?date='+this.dayForSelect
          }
        }).then((res)=>{
          const data = JSON.parse(res.data.data).data;
          console.log(data)
          // quantity  = -1的时候代表预约满了 0是不限名额预约
          // daysInAdvance 是提前多少天预约
          let amList = [];
          let amListNone = [];
          let pmList = [];
          let pmListNone = [];
          let recordsList = data.records;
          let employeesList = data.employees;
          for(let i = 0;i<recordsList.length;i++){
            for(let j=0;j<employeesList.length;j++){
              if(employeesList[j].id==recordsList[i].employeeId){
                if(recordsList[i].quantity>=0){
                  if(recordsList[i].am && recordsList[i].pm){ //am && pm
                    amList.push({
                      avatar:employeesList[j].avatar,
                      name:employeesList[j].name,
                      quantity:recordsList[i].quantity,
                      employeeId:recordsList[i].employeeId,
                      scheduleId:recordsList[i].id,
                      period:'am',
                      showSec:1,
                      am:recordsList[i].am,
                    })
                    pmList.push({
                      avatar:employeesList[j].avatar,
                      name:employeesList[j].name,
                      quantity:recordsList[i].quantity,
                      employeeId:recordsList[i].employeeId,
                      scheduleId:recordsList[i].id,
                      period:'pm',
                      showSec:2,
                      pm:recordsList[i].pm,
                    })
                  }else if(recordsList[i].am && !recordsList[i].pm){
                    amList.push({
                      avatar:employeesList[j].avatar,
                      name:employeesList[j].name,
                      quantity:recordsList[i].quantity,
                      employeeId:recordsList[i].employeeId,
                      scheduleId:recordsList[i].id,
                      period:'am',
                      showSec:1,
                      am:recordsList[i].am,
                    })
                  }else{
                    pmList.push({
                      avatar:employeesList[j].avatar,
                      name:employeesList[j].name,
                      quantity:recordsList[i].quantity,
                      employeeId:recordsList[i].employeeId,
                      scheduleId:recordsList[i].id,
                      period:'pm',
                      showSec:2,
                      pm:recordsList[i].pm,
                    })
                  }
                }else{
                  if(recordsList[i].am && recordsList[i].pm){
                    amListNone.push({
                      avatar:employeesList[j].avatar,
                      name:employeesList[j].name,
                      quantity:recordsList[i].quantity,
                      employeeId:recordsList[i].employeeId,
                      scheduleId:recordsList[i].id,
                      period:'am',
                      showSec:3,
                      am:recordsList[i].am,
                    })
                    pmListNone.push({
                      avatar:employeesList[j].avatar,
                      name:employeesList[j].name,
                      quantity:recordsList[i].quantity,
                      employeeId:recordsList[i].employeeId,
                      scheduleId:recordsList[i].id,
                      period:'pm',
                      showSec:4,
                      pm:recordsList[i].pm,
                    })
                  }else if(recordsList[i].am && !recordsList[i].pm){
                    amListNone.push({
                      avatar:employeesList[j].avatar,
                      name:employeesList[j].name,
                      quantity:recordsList[i].quantity,
                      employeeId:recordsList[i].employeeId,
                      scheduleId:recordsList[i].id,
                      period:'am',
                      showSec:3,
                      am:recordsList[i].am,
                    })
                  }else{
                    pmListNone.push({
                      avatar:employeesList[j].avatar,
                      name:employeesList[j].name,
                      quantity:recordsList[i].quantity,
                      employeeId:recordsList[i].employeeId,
                      scheduleId:recordsList[i].id,
                      period:'am',
                      showSec:4,
                      pm:recordsList[i].pm,
                    })
                  }
                }
              }

            }
          }
          this.docList = [...amList,...pmList,...amListNone,...pmListNone];
          console.log(this.docList)
        }).catch((err)=>{
          console.log(err);
        });
      },
      // 根据日期获取医生列表
      getDocListByDate(day,index){
        this.dayForSelect = day;
        this.activeIndex = index;
        this.getDocList(this.patientUUID);
        this.value1=day.substr(0,4)+'-'+day.substr(4,2)+'-'+day.substr(6,2)
      },
      // 跳转预约提示
      toApplyTips(quantity,scheduleId,period){
        if(quantity<0){
          this.$toast('今日预约已满')
          return
        }
        this.axios.post(order.orderCreate,{
          money:this.orderFee,
          openId:this.openid,
          patientId:this.patientId,       //病人id（云鹊）
          patientUUID:this.patientUUID,   //病人id（外部系统）
          scheduleId:scheduleId,    //医生排班表ID
          period:period             //am/pm 时间段
        }).then((res)=>{
          if(res.status==200&&res.data.code=='000000'){
            const orderNo = res.data.data.orderNo;
            this.store.commit('set_order_status',true);
            // this.store.commit('get_order_no',orderNo);
            localStorage.setItem('orderNo', orderNo);
            this.$router.push({
              path:'/payApply',
            });
          }else{
            this.$toast(res.data.message)
          }
        });
      },
      getyyyyMMdd(date){
        let d = date || new Date();
        let curr_date = d.getDate();
        let curr_month = d.getMonth() + 1;
        let curr_year = d.getFullYear();
        String(curr_month).length < 2 ? (curr_month = "0" + curr_month): curr_month;
        String(curr_date).length < 2 ? (curr_date = "0" + curr_date): curr_date;
        let yyyyMMdd = curr_year + "" + curr_month +""+ curr_date;
        return yyyyMMdd;
      },
      getMMdd(date){
        let d = date || new Date();
        let curr_date = d.getDate();
        let curr_month = d.getMonth() + 1;
        String(curr_month).length < 2 ? (curr_month = "0" + curr_month): curr_month;
        String(curr_date).length < 2 ? (curr_date = "0" + curr_date): curr_date;
        let MMdd = curr_month +"-"+ curr_date;
        return MMdd;
      },
      getWeekDaysList(data){
        const weekList=["周日","周一","周二","周三","周四","周五","周六"];
        let d = data || new Date();
        let secd = d.getDay();
        for(let i=secd+1;i<7;i++){
          this.dayList.push({
            weekDay:weekList[i],
          })
        }
        for(let i=0;i<secd+1;i++){
          this.dayList.push({
            weekDay:weekList[i],
          })
        }
        for(let i=0;i<7;i++){
          this.dayList[i].day = this.getMMdd(new Date(d.getTime()+(i+1)*24*60*60*1000))
          this.dayList[i].date = this.getyyyyMMdd(new Date(d.getTime()+(i+1)*24*60*60*1000))
        }
      },
      changeDate(){
        this.dayList=[];
        this.activeIndex=0;
        this.dayForSelect = this.getyyyyMMdd(this.value1);
        this.getWeekDaysList(new Date(new Date(this.value1).getTime()-24*60*60*1000));
        this.active=0;
        this.getDocList(this.patientUUID);
      },
      calFocus(){
        this.isShow=true;
      },
      calBlur(){
        this.isShow=false;
      }
    }
  }
</script>


<style scoped lang="scss">
  .container{
    width:375px;
    height:667px;
    background:#F8F8F8;
    position: relative;
    .mask{
      width:375px;
      height:667px;
      position: absolute;
      left:0;
      top:0;
      background:rgba(0,0,0,.5);
      z-index: 100;
    }
    .accept{
      min-height:667px;
      .help_head{
        height:50px;
        border-bottom:1px solid #eee;
        background:$bgfff;
        position: relative;
        z-index: 1000;
        div{
          display:inline-block;
        }
        .help_head_msg{
          padding-top:20px;
          padding-left:15px;
          @include text_font('PingFangSC',13px,normal,#999999,left);
        }
        .help_head_all{
          margin-left:45px;
          @include text_font('PingFangSC',15px,normal,#333,left);
          img{
            display: inline;
            width:25px;
            height:25px;
          }
        }
      }
      .help_days{
        width:375px;
        height:46px;
        margin-bottom: 6px;

        background:$bgfff;
        @include layout_row_root();
        .help_list_box{
          width:52px;
          height:46px;
          border-left:$baseBorder;
          @include layout_row();
          @include text_font('PingFangSC',13px,normal,#999,center);
          span{
            display: block;
          }
          span:nth-child(1){
            margin-top:7px;
          }
          span:nth-child(2){
            font-size:12px;
          }
        }
        .active{
          width:55px;
          border:none;
          background:#41B7A7;
          @include text_font('PingFangSC',13px,normal,#fff,center);
        }
      }
      .help_list{
        background:$bgfff;
        ul{
          li{
            height:90px;
            border-bottom:$baseBorder;
            padding:20px 15px;
            @include layout_row_root();
            img{
              width:55px;
              height:55px;
              border-radius: 50%;
            }
            .lay_row{
              vertical-align: middle;
              @include layout_row();
              .doc_name{
                @include text_font('PingFangSC',16px,normal,#333,center);
              }
              .doc_job{
                margin-left:7px;
                @include text_font('PingFangSC',14px,normal,#666,center);
              }
              .doc_time{
                width:120px;
                height:18px;
                line-height:15px;
                margin-top:15px;
                border-radius: 2px;
              }
              .doc_am{
                @include border(1px,solid,rgba(74, 144, 266, 0.35));
                @include text_font('PingFangSC',12px,normal,rgba(74, 144, 266, 1),center);
              }
              .doc_pm{
                @include border(1px,solid,rgba(65,183,167, 0.35));
                @include text_font('PingFangSC',12px,normal,rgba(65,183,167, 1),center);
              }
              .doc_no{
                @include border(1px,solid,rgba(153,153,153, 0.35));
                @include text_font('PingFangSC',12px,normal,rgba(153,153,153, 1),center);
              }
            }
            .marLeft10{
              margin-left:10px;
            }
            .btn_apply{
              width:45px;
              height:20px;
              line-height:20px;
              background:#FFC514;
              border-radius:10px;
              float:right;
              @include text_font('PingFangSC',12px,normal,#fff,center);
            }
            .unApply{
              background:#F6F6F6;
              color:#999999;
            }
          }
        }
      }
    }
  }
  .isHidden{
    overflow:hidden;
  }
</style>
<style>
  .picker{
    width:375px!important;
    height:37px;
    z-index: 1000;
  }
  .picker input{
    width:375px!important;
    height:37px!important;
    background:rgba(65,183,167,0.08)!important;
    border:0;
    text-align: center;
  }
  .el-picker-panel{
    width:375px;
    margin:0!important;
    border-radius: 0;
  }
  .el-picker-panel__content{
    width:345px!important;
  }
  .el-input__suffix{
    display:none!important;
  }
  .el-input__prefix{
    right:5px!important;
    text-align: right!important;
  }
  .el-input__icon{
    width:100px!important;
    color:#494949!important;
    text-align: right!important;
  }
</style>



// WEBPACK FOOTER //
// src/views/doorHelp/applyIndex.vue